histories-approval-canceled-by-sales-manager
  span.event {this.locale().event}
  script(type="typescript").
    this.mixin('histories.base');
